import { Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'app-preview-alerts',
  templateUrl: './previewAlerts.component.html',
  styleUrls: ['./previewAlerts.component.scss']
})
export class PreviewAlertsComponent implements OnInit {

    @Input() alerts: any = [];
    filters: any = [];
    fields: any = [];
    sortField: string = '';
    selectedTab: string = '';
    tableData: any = [];
    data: any = [];

    tables: any = {
        'Room': [{ name: "Unit", property: "unitName" }, { name: "Facility/Area", property: "locationName" }, { name: "Room", property: "roomNumber" }, { name: "Activity", property: "activityName" }, { name: "Issue Type", property: "issueType" }, { name: "Suggested Resolution", property: "suggestedResolution" }],
        'Location': [{ name: "Unit", property: "unitName" }, { name: "Facility/Area", property: "locationName" }, { name: "Type", property: "locationType" }, { name: "Activity", property: "activityName" }, { name: "Issue Type", property: "issueType" }, { name: "Suggested Resolution", property: "suggestedResolution" }],
        'Staff': [{ name: "Unit", property: "unitName" }, { name: "Staff", property: "staffName" }, { name: "Issue Type", property: "issueType" }, { name: "Suggested Resolution", property: "suggestedResolution" }],
        'StaffActivity': [{ name: "Activity", property: "activityName" }, { name: "Issue Type", property: "issueType" }, { name: "Suggested Resolution", property: "suggestedResolution" }],
        '': []
    };

    constructor() { }

    ngOnInit() {
        this.alerts.roomIssues.length !== 0 ? this.openTab('Room') : this.alerts.locationIssues.length !== 0 ? this.openTab('Location') : this.alerts.staffAttendanceIssues.length !== 0 ? this.openTab('Staff') : this.openTab('StaffActivity');
        this.fields = this.tables[this.selectedTab];
        this.initFilters();
    }

    public initFilters() {
        this.fields.forEach(key => this.filters[key.property] = { model: "", sortOrder: true });
        if (this.fields.length > 0) {
            this.sortBy(this.fields[0].property);
        }
    }

    public sortBy(field: string) {
        if (this.sortField === field) {
            this.filters[field].sortOrder = !this.filters[field].sortOrder;
        }
        else {
            this.sortField = field;
        }
        
        this.performFiltering();
    }

    public performFiltering() {
        let result = this.tableData.filter(item => {
            let exclude = false;
            this.fields.forEach(field => {
                exclude = exclude || item[field.property].toLowerCase().indexOf(this.filters[field.property].model.toLowerCase()) === -1;
            });
            return !exclude;
        });
        this.data = result;

        this.data = this.data.sort((a, b) => {
            return this.filters[this.sortField].sortOrder ? (a[this.sortField].toLowerCase() > b[this.sortField].toLowerCase() ? 1 : -1) : (b[this.sortField].toLowerCase() > a[this.sortField].toLowerCase() ? 1 : -1);
        });
    }

    public openTab(type: string) {
        this.selectedTab = type;
        this.fields = this.tables[type];
        switch (type) {
            case 'Room':
                this.tableData = this.alerts.roomIssues;
                break;
            case 'Location':
                this.tableData = this.alerts.locationIssues;
                break;
            case 'Staff':
                this.tableData = this.alerts.staffAttendanceIssues;
                break;
            case 'StaffActivity':
                this.tableData = this.alerts.staffActivityIssues;
                break;

        }
        this.initFilters();
    }


    public getAlertsCount(type: string) {
        switch (type) {
            case 'Room':
                return this.alerts.roomIssues.length;
            case 'Location':
                return this.alerts.locationIssues.length;
            case 'Staff':
                return this.alerts.staffAttendanceIssues.length;
            case 'StaffActivity':
                return this.alerts.staffActivityIssues.length;

        }

    }


    public isLinkField(field) {
        switch (this.selectedTab) {
            case 'Room':
                return field === 'roomNumber' ? true : false;
            case 'Location':
                return field === 'locationName' ? true : false;
            case 'Staff':
                return field === 'staffName' ? true : false;
            case 'StaffActivity':
                return field === 'activityName' ? true : false;
        }
    }

    public OpenLink(row) {
        switch (this.selectedTab) {
            case 'Room':
                this.OpenNewTab({ ROOM_NO: row['roomNumber'], FCLTY_CD: row['facilityCode'] });
                break;
            case 'Location':
                this.OpenNewTab({ LOCATION: row['locationId'], Type: row['locationType'] });
                break;
            case 'Staff':
                this.OpenNewTab({ PERS_ID: row['staffId'] });
                break;
            case 'StaffActivity':
                this.OpenNewTab({ PK_RSACT: row['activityId']});
                break;
        }
    }

    private OpenNewTab(params) {
        let url = window.location.href;
        let path = '';
        switch (this.selectedTab) {
            case 'Room':
                path = 'grid/profile/400078/400807?ROOM_NO=' + params.ROOM_NO + '&FCLTY_CD=' + params.FCLTY_CD;
                break;
            case 'Location':
                if (params.Type === 'Facility') {
                    path = 'grid/profile/400078/400806?FCLTY_CD=' + params.LOCATION;
                }
                else if (params.Type === 'Area') {
                    path = 'grid/profile/400078/400809?PK_AREAS=' + params.LOCATION;
                }
                break;
            case 'Staff':
                path = 'grid/profile/400078/400805?PERS_ID=' + params.PERS_ID;
                break;
            case 'StaffActivity':
                path = 'grid/listGrid/400078/400753?PK_RSACT=' + params.PK_RSACT;
                break;
        }
        url = url.split('/')[0] + path;
        window.open(url, '_blank');
    }

}
